import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "D",
  "use": "D-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"D\"><title>D</title><path d=\"M8.2 18V6.6H12c1.3 0 2.5.5 3.5 1.4.9.9 1.4 2.2 1.4 3.5v1.7c0 1.3-.4 2.6-1.4 3.5-1 .9-2.2 1.3-3.5 1.3H8.2zm1.9-9.8v8.3H12c.8 0 1.6-.3 2.2-.9.6-.7.8-1.5.8-2.4v-1.7c0-.9-.3-1.7-.8-2.4-.5-.6-1.3-1-2.2-.9h-1.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/D.svg
// module id = HeH6
// module chunks = 6